import $$ from 'lodash';

const state = {
	invoiceNumber: '',
	invoiceTitle: '',
	items: [],
    payments: [],
    selectedContact: '',
    selectedDepositToContact : '',
    invoiceMemo: '',
	invoiceObj: null,
	editInvoiceObj: {},
	createInvoiceObj: {},
	currentPaymentLine: null,
	paymentAmount: 0,
	isEditingInvoice: false
};

const getters = {
	
};

const mutations = {
	clearInvoiceDetails(state) {
        state.invoiceTitle = ''
        state.invoiceNumber = ''
        state.invoiceMemo = ''
	},
	setInvoiceMemo(state, memo){
		state.invoiceMemo = memo
	},
	clearInvoiceMemo(state) {
        state.invoiceMemo = '';
	},
	setInvoiceObj(state, invoiceObj) {
        state.invoiceObj = invoiceObj;
    },
    clearInvoiceObj(state) {
        state.invoiceObj = null
	},
	clearItems(state) {
        state.items = []
    },
    clearPayments(state) {
        state.payments = []
    },
    setSelectedContact({commit}, selectedContact){
        state.selectedContact =  selectedContact;
    },
    clearSelectedContact(state) {
        state.selectedContact = ''
    },
    setDepositContact(state, contact){
        state.setDepositContact = contact;
    },
    clearSelectedDepositToContact(state) {
        state.selectedDepositToContact = ''
	},
	pushItem(state, item) {
        state.items.push(item)
    },
    pushPayment(state, data) {
        let payment = data.payment;
        // create empty obj in array index;
        if (state.payments[data.index] === undefined) {
            state.payments[data.index] = {};
        }
        if (payment.method_name) {
            state.payments[data.index].method_name = payment.method_name;
        }
        if (payment.method_id) {
            state.payments[data.index].method_id = payment.method_id;
        }
        if (payment.account_id) {
            state.payments[data.index].account_id = payment.account_id;
        }
        if (payment.account_name) {
            state.payments[data.index].account_name = payment.account_name 
        }
        if (payment.amount) {
            state.payments[data.index].amount = payment.amount; 
        }
	},
	setEditInvoiceObj(state, editInvoiceObj){
		$$.each(editInvoiceObj, (value, key) => {
			//  if (key === 'partials') {
			// 	if (state.editInvoiceObj[key] === undefined) {
			// 		console.log(undefined);
			// 		state.editInvoiceObj[key] = [];
			// 		state.editInvoiceObj[key][value.index] = value.partial;
			// 	} else {
					
			// 		if (state.editInvoiceObj[key][value.index] === undefined) {
			// 			state.editInvoiceObj[key][value.index] = {};
			// 		}
			// 		var partialObject = state.editInvoiceObj[key][value.index];
			// 		$$.each(value.partial, (value, key) => {
			// 			partialObject[key] = value;						
			// 		});
			// 		state.editInvoiceObj[key][value.index] = partialObject;
			// 	}
			
				console.log(key);
				state.editInvoiceObj[key] = value;
			// }
		});
	},
	setEditInvoiceItem(state, item) {
		state.editInvoiceObj.items.push(item)
	},
	setEditInvoicePartial(state, partial) {
		console.log(partial);
		if (state.editInvoiceObj.partials[partial.index] === undefined) {
			state.editInvoiceObj.partials[partial.index] = {};
		}
		if (partial.partial.method_id ) {
			state.editInvoiceObj.partials[partial.index].method_name = partial.partial.method_name; 
			state.editInvoiceObj.partials[partial.index].method_id = partial.partial.method_id;
		}
		if (partial.partial.account_id) {
			state.editInvoiceObj.partials[partial.index].account_name = partial.partial.account_name; 
			state.editInvoiceObj.partials[partial.index].account_id = partial.partial.account_id;
		}
		if (partial.partial.amount){
			state.editInvoiceObj.partials[partial.index].amount = partial.partial.amount; 
			state.editInvoiceObj.partials[partial.index].amount = partial.partial.amount;
		}
	},
	setCreateInvoiceObj(state, createInvoiceObj){
		$$.each(createInvoiceObj, (value, key) => {
			if (key === 'items'){
				if (state.createInvoiceObj[key] === undefined) {
					state.createInvoiceObj[key] = [];
				}
				state.createInvoiceObj[key].push(value);
			} else if (key === 'partials') {
				if (state.createInvoiceObj[key] === undefined) {
					console.log(undefined);
					state.createInvoiceObj[key] = [];
					state.createInvoiceObj[key][value.index] = value.partial;
				} else {
					
					if (state.createInvoiceObj[key][value.index] === undefined) {
						state.createInvoiceObj[key][value.index] = {};
					}
					var partialObject = state.createInvoiceObj[key][value.index];
					$$.each(value.partial, (value, key) => {
						partialObject[key] = value;						
					});
					state.createInvoiceObj[key][value.index] = partialObject;
				}
			} else {
				state.createInvoiceObj[key] = value;
			}
			
		});
	},
	setInvoiceNumber(state, invoiceNumber){
		state.invoiceNumber = invoiceNumber;
	},
	removeItem(state, index) {
        state.createInvoiceObj.items.splice(index, 1);
	},
	removeItemEditInvoice(state, index){
		state.editInvoiceObj.items.splice(index, 1);
	},
	removePayment(state, index) {
        state.createInvoiceObj.partials.splice(index, 1);
	},
	removePaymentEditInvoice(state, index) {
		if (state.editInvoiceObj.partials[index].id){
			state.editInvoiceObj.partials[index].is_deleted = true;
		} else {
			state.editInvoiceObj.partials.splice(index, 1);
		}
    },
	setCurrentPaymentLine (state, currentPaymentLine) {
        state.currentPaymentLine = currentPaymentLine
	},
	changeItemDescription(state, data){
		state.createInvoiceObj.items[data.index].name = data.name;
	},
	changeItemDiscount(state, data) {
		state.createInvoiceObj.items[data.index].discount = data.discount;
	},
	changeItemUnitPrice(state, data) {
		state.createInvoiceObj.items[data.index].unit_price = data.unit_price;
	},
	setPaymentAmount(state, amount) {
		state.paymentAmount = amount;
	},
	changeItemQuantity(state, data) {
		state.createInvoiceObj.items[data.index].quantity = data.quantity;
	},
	changeItemQuantityEditInvoice(state, data) {
		state.editInvoiceObj.items[data.index].quantity = data.quantity;
	},
	clearCreateInvoiceData(state){
		state.createInvoiceObj = {}
		state.currentPaymentLine  = null;
		state.paymentAmount = null
	},
	clearEditInvoiceData(state){
		state.editInvoiceObj = {}
		state.currentPaymentLine  = null;
		state.paymentAmount = null
	},
	setIsEditingInvoice(state, isEditing) {
		state.isEditingInvoice = isEditing;
	}
	
};

const actions = {
	clearInvoiceDetails({commit}) {
		commit('clearInvoiceDetails');
	},
	setInvoiceMemo({commit}, memo) {
		commit('setInvoiceMemo');
	},
	clearItems({commit}){
        commit('clearItems');
    },
    clearPayments({commit}) {
        commit('clearPayments');
    },
    setSelectedContact({commit}, selectedContact){
        commit('setSelectedContact', selectedContact);
    },
    clearSelectedContact({commit}){
        commit('clearSelectedContact');
    },
    setDepositContact({commit}, contact) {
        commit('setDepositContact', contact)
    },
    clearSelectedDepositToContact({commit}) {
        commit('clearSelectedDepositToContact');
    },
    clearInvoiceMemo({commit}) {
        commit('clearInvoiceMemo');
    },
    setInvoiceObj({commit}, invoiceObj) {
        commit('setInvoiceObj', invoiceObj);
    },
    clearInvoiceObj({commit}) {
        commit('clearInvoiceObj');
    },
    selectContact({commit}, contact) {
        commit('selectContact', contact)
	},
	pushItem({commit}, item) {
        commit('pushItem', item)
	},
	pushPayment({commit}, data){
        commit('pushPayment', data)
	},
	setEditInvoiceObj({commit}, editInvoiceObj){
		commit('setEditInvoiceObj', editInvoiceObj);
	},
	setCreateInvoiceObj({commit}, createInvoiceObj){
		commit('setCreateInvoiceObj', createInvoiceObj);
	},
	setInvoiceNumber({commit}, invoiceNumber) {
		commit('setInvoiceNumber', invoiceNumber);
	},
	removeItem({commit}, index) {
		commit('removeItem', index);
	},
	removeItemEditInvoice({commit}, index){
		commit('removeItemEditInvoice', index);
	},
	removePayment({commit}, index) {
		commit('removePayment', index);
	},
	setCurrentPaymentLine ({commit}, currentPaymentLine) {
        commit('setCurrentPaymentLine', currentPaymentLine);
	},
	changeItemDescription({commit}, data) {
		commit('changeItemDescription', data);
	},
	changeItemDiscount({commit}, data){
		commit('changeItemDiscount', data);
	},
	changeItemUnitPrice({commit}, data) {
		commit('changeItemUnitPrice', data);
	},
	setPaymentAmount({commit}, amount){
		commit('setPaymentAmount', amount);
	},
	changeItemQuantity({commit}, data) {
		commit('changeItemQuantity', data)
	},
	changeItemQuantityEditInvoice({commit}, data) {
		commit('changeItemQuantityEditInvoice', data)
	},
	clearCreateInvoiceData({commit}) {
		commit('clearCreateInvoiceData');
	},
	clearEditInvoiceData({commit}) {
		commit('clearEditInvoiceData');
	},
	setIsEditingInvoice({commit}, isEditing){
		commit('setIsEditingInvoice', isEditing)
	},
	removePaymentEditInvoice({commit}, index) {
		commit('removePaymentEditInvoice', index);
	},
	setEditInvoiceItem({commit}, item) {
		commit('setEditInvoiceItem', item);
	},
	setEditInvoicePartial({commit}, data) {
		commit('setEditInvoicePartial', data);
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};